import { createDrawerEventBinder, snapQuantity } from './cart_drawer_utils.js';

export function initCartDrawerItemActions({ getDrawer, setLoading, load, qty_errors, drawerSelector }) {
    const onDrawer = createDrawerEventBinder(drawerSelector);

    // Mantém as quantidades alinhadas às regras de venda múltipla e kits.
    function updateOutfitQty($qty, quantity) {
        quantity = snapQuantity($qty, quantity);
        $qty.find('.cart-drawer-qty__input').val(quantity);
        setLoading(true);

        $.ajax({
            url: 'index.php?route=checkout/cart/editOutfit',
            type: 'post',
            data: { key: $qty.attr('data-outfit-keys'), quantity: quantity },
            dataType: 'json',
            complete: function() {
                load();
            }
        });
    }

    // Quantidade de um item
    function updateQty($qty, quantity) {
        if ($qty.attr('data-outfit-keys')) {
            updateOutfitQty($qty, quantity);
            return;
        }

        const key = $qty.attr('data-key');

        quantity = snapQuantity($qty, quantity);
        $qty.find('.cart-drawer-qty__input').val(quantity);
        setLoading(true);

        $.ajax({
            url: 'index.php?route=common/cart_drawer/update',
            type: 'post',
            data: { key: key, quantity: quantity },
            dataType: 'json',
            success: function(json) {
                // Aviso (ex.: estoque insuficiente) fica visível ao lado da quantidade já corrigida pelo servidor
                if (json && json.error) {
                    qty_errors[key] = json.error;
                } else {
                    delete qty_errors[key];
                }
            },
            complete: function() {
                load();
            }
        });
    }

    onDrawer('click', '.cart-drawer-qty [data-qty-step]', function() {
        const $qty = $(this).closest('.cart-drawer-qty');
        const current = parseInt($qty.find('.cart-drawer-qty__input').val(), 10) || 1;

        const step = Math.max(1, parseInt($qty.attr('data-step'), 10) || 1);

        updateQty($qty, current + parseInt($(this).data('qty-step'), 10) * step);
    });

    onDrawer('change', '.cart-drawer-qty__input', function() {
        updateQty($(this).closest('.cart-drawer-qty'), $(this).val());
    });

    // Kit: ver/ocultar os produtos do kit
    onDrawer('click', '[data-cart-drawer-outfit-toggle]', function() {
        const $toggle = $(this);
        const $list = $toggle.siblings('.cart-drawer-outfit__list');
        const expanded = $toggle.attr('aria-expanded') === 'true';

        $list.prop('hidden', expanded);
        $toggle.attr('aria-expanded', expanded ? 'false' : 'true');
        $toggle.find('span').text($toggle.attr(expanded ? 'data-text-show' : 'data-text-hide'));
    });

    // Remover kit (todos os produtos dele)
    onDrawer('click', '[data-cart-drawer-remove-outfit]', function() {
        setLoading(true);

        $.ajax({
            url: 'index.php?route=checkout/cart/remove',
            type: 'post',
            data: { key: $(this).attr('data-cart-drawer-remove-outfit'), outfit: 'true' },
            dataType: 'json',
            complete: function() {
                load();
            }
        });
    });

    // Remover item
    onDrawer('click', '[data-cart-drawer-remove]', function() {
        setLoading(true);

        $.ajax({
            url: 'index.php?route=checkout/cart/remove',
            type: 'post',
            data: { key: $(this).data('cart-drawer-remove') },
            dataType: 'json',
            complete: function() {
                load();
            }
        });
    });

    // Sugestões: setas do carrossel
}
